export enum AdminCompaniesActionTypes {
  GET_ADMIN_COMPANIES = 'Admin/GET_ADMIN_COMPANIES',
  SET_IS_LOADING = 'Admin/SET_IS_LOADING',
  SET_BREADCRUMBS = 'Admin/SET_BREADCRUMBS',
  SET_CURRENTLY_DISPLAYED_ARTICLE = 'Admin/SET_CURRENTLY_DISPLAYED_ARTICLE',
  GET_ADMIN_COMPANY_TRANSACTIONS = 'Admin/GET_ADMIN_COMPANY_TRANSACTIONS',
  GET_ADMIN_COMPANY_TRANSACTIONS_TO_DOWNLOAD = 'Admin/GET_ADMIN_COMPANY_TRANSACTIONS_TO_DOWNLOAD',
  SET_IS_GETTING_ADMIN_COMPANY_TRANSACTIONS_TO_DOWNLOAD = 'Admin/SET_IS_GETTING_ADMIN_COMPANY_TRANSACTIONS_TO_DOWNLOAD',
}
